import {createI18n} from "vue-i18n";
import messages from './locales.js'

const i18n = createI18n({
    legacy: false,
    locale: JSON.parse(localStorage.getItem('Language') ?? '{"language":"ko"}').language,
    messages,
})

export default i18n
